import React, { useState } from 'react';
import { useTranslation } from '../../utils/i18nStub';

const employmentTypeOptions = [
  { value: 'government', label: 'جهة حكومية' },
  { value: 'private', label: 'قطاع خاص' },
  { value: 'charity', label: 'جمعية خيرية' },
  { value: 'other', label: 'جهة أخرى' },
];

const governmentOrgOptions = [
  { value: '', label: 'اختر الجهة الحكومية' },
  { value: 'moi', label: 'وزارة الداخلية' },
  { value: 'moe', label: 'وزارة التعليم' },
  { value: 'moh', label: 'وزارة الصحة' },
  { value: 'mlsd', label: 'وزارة الموارد البشرية والتنمية الاجتماعية' },
];

const regions = [
  { value: 'riyadh', label: 'منطقة الرياض' },
  { value: 'makkah', label: 'منطقة مكة المكرمة' },
  { value: 'madinah', label: 'منطقة المدينة المنورة' },
  { value: 'sharqiah', label: 'المنطقة الشرقية' },
  { value: 'qasem', label: 'منطقة القصيم' },
  { value: 'asir', label: 'منطقة عسير' },
  { value: 'tabuk', label: 'منطقة تبوك' },
];

const cities = {
  riyadh: ['الرياض', 'الخرج', 'وادي الدواسر', 'الدوادمي'],
  makkah: ['مكة المكرمة', 'جدة', 'الطائف'],
  madinah: ['المدينة المنورة', 'العلا', 'ينبع'],
  sharqiah: ['الدمام', 'الخبر', 'الجبيل'],
};

const centers = ['المركز الرئيسي', 'فرع الشمال', 'فرع الجنوب', 'فرع الشرق', 'فرع الغرب'];

const EmployeeOtherEmployment = () => {
  const { t } = useTranslation('otherEmployment');

  const [employmentType, setEmploymentType] = useState('government');
  const [governmentOrg, setGovernmentOrg] = useState('');
  const [privateOrgName, setPrivateOrgName] = useState('');
  const [region, setRegion] = useState('');
  const [city, setCity] = useState('');
  const [center, setCenter] = useState('');
  const [attachmentName, setAttachmentName] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [snapshot, setSnapshot] = useState({ employmentType, governmentOrg, privateOrgName, region, city, center, attachmentName });

  const selectedCityOptions = region && cities[region] ? cities[region] : [];

  const handleAttachmentChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      setAttachmentName('');
      return;
    }
    setAttachmentName(file.name);
  };

  const captureSnapshot = () => {
    setSnapshot({ employmentType, governmentOrg, privateOrgName, region, city, center, attachmentName });
  };

  const startEdit = () => {
    captureSnapshot();
    setIsEditing(true);
  };

  const handleCancel = () => {
    setEmploymentType(snapshot.employmentType);
    setGovernmentOrg(snapshot.governmentOrg);
    setPrivateOrgName(snapshot.privateOrgName);
    setRegion(snapshot.region);
    setCity(snapshot.city);
    setCenter(snapshot.center);
    setAttachmentName(snapshot.attachmentName);
    setIsEditing(false);
  };

  const handleSave = () => {
    captureSnapshot();
    setIsEditing(false);
  };

  return (
    <div className="space-y-6 text-right" dir="rtl">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-gray-900 mb-1">
          {t('otherEmployment.title', 'جهات عمل أخرى')}
        </h2>
        {!isEditing ? (
          <button
            type="button"
            onClick={startEdit}
            className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
          >
            {t('edit', 'تعديل')}
          </button>
        ) : (
          <div className="flex gap-2">
            <button
              type="button"
              onClick={handleSave}
              className="rounded-xl bg-sa-600 text-white px-4 py-2 text-sm font-semibold hover:bg-sa-700 transition-colors"
            >
              {t('save', 'حفظ')}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
            >
              {t('cancel', 'إلغاء')}
            </button>
          </div>
        )}
      </div>

      <section className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Employment Type */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-500 mb-2">
              {t('otherEmployment.employmentType', 'اختر نوع جهة العمل الأخرى')}
            </label>
            <select
              value={employmentType}
              onChange={(event) => {
                setEmploymentType(event.target.value);
                setGovernmentOrg('');
                setPrivateOrgName('');
              }}
              className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500"
              disabled={!isEditing}
            >
              {employmentTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* Government Organization */}
          {employmentType === 'government' && (
            <div className="flex flex-col">
              <label className="text-sm font-semibold text-gray-500 mb-2">
                {t('otherEmployment.govOrg', 'اختر اسم الجهة الحكومية')}
              </label>
              <select
                value={governmentOrg}
                onChange={(event) => setGovernmentOrg(event.target.value)}
                className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500"
                disabled={!isEditing}
              >
                {governmentOrgOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Private Organization Name */}
          {employmentType !== 'government' && (
            <div className="flex flex-col">
              <label className="text-sm font-semibold text-gray-500 mb-2">
                {t('otherEmployment.privateOrgName', 'اكتب اسم الجهة (قطاع خاص أو جهة أخرى)')}
              </label>
              <input
                type="text"
                value={privateOrgName}
                onChange={(event) => setPrivateOrgName(event.target.value)}
                placeholder={t('otherEmployment.privateOrgPlaceholder', 'مثال: شركة الاتصالات السعودية')}
                className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500"
                readOnly={!isEditing}
                disabled={!isEditing}
              />
            </div>
          )}

          {/* Region */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-500 mb-2">
              {t('otherEmployment.region', 'المنطقة')}
            </label>
            <select
              value={region}
              onChange={(event) => {
                setRegion(event.target.value);
                setCity('');
              }}
              className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500"
              disabled={!isEditing}
            >
              <option value="">{t('otherEmployment.selectRegion', 'اختر المنطقة')}</option>
              {regions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {/* City */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-500 mb-2">
              {t('otherEmployment.city', 'المدينة')}
            </label>
            <select
              value={city}
              onChange={(event) => setCity(event.target.value)}
              disabled={!isEditing || !region}
              className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500 disabled:bg-gray-100 disabled:text-gray-400"
            >
              <option value="">{t('otherEmployment.selectCity', 'اختر المدينة')}</option>
              {selectedCityOptions.map((name) => (
                <option key={name} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          {/* Center */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-500 mb-2">
              {t('otherEmployment.center', 'المركز / الفرع')}
            </label>
            <select
              value={center}
              onChange={(event) => setCenter(event.target.value)}
              className="rounded-xl border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-sa-500"
              disabled={!isEditing}
            >
              <option value="">{t('otherEmployment.selectCenter', 'اختر المركز أو الفرع')}</option>
              {centers.map((label) => (
                <option key={label} value={label}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Attachment */}
        <div className="mt-6">
          <label className="text-sm font-semibold text-gray-500 mb-2 block">
            {t('otherEmployment.attachment', 'خطاب التعريف / خطاب جهة العمل')}<span className="text-gray-400"> ({t('otherEmployment.attachmentHint', 'PDF أو صورة')})</span>
          </label>
          <div className="border-2 border-dashed border-gray-300 rounded-2xl p-6 text-center bg-gray-50">
            <p className="text-sm text-gray-600 mb-4">
              {t('otherEmployment.attachmentDesc', 'قم بإرفاق خطاب رسمي صادر من الجهة يوضح عملك ودورك الوظيفي.')}
            </p>
            <label className="inline-flex items-center gap-2 rounded-xl bg-sa-600 text-white px-5 py-2 text-sm font-semibold hover:bg-sa-700 transition-colors cursor-pointer">
              <input type="file" className="hidden" accept=".pdf,.jpg,.jpeg,.png" onChange={handleAttachmentChange} disabled={!isEditing} />
              {t('otherEmployment.upload', 'اختيار ملف')}
            </label>
            {attachmentName && (
              <p className="mt-3 text-sm text-gray-700">
                {t('otherEmployment.selectedFile', 'الملف المحدد')}: {attachmentName}
              </p>
            )}
          </div>
        </div>

        {isEditing && (
          <footer className="flex justify-end gap-3 pt-6 border-t border-gray-100 mt-6">
            <button
              type="button"
              onClick={handleCancel}
              className="rounded-xl border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-100 transition-colors"
            >
              {t('otherEmployment.cancel', 'إلغاء')}
            </button>
            <button
              type="button"
              onClick={handleSave}
              className="rounded-xl bg-sa-600 text-white px-5 py-2 text-sm font-semibold hover:bg-sa-700 transition-colors disabled:opacity-50"
              disabled={
                (employmentType === 'government' && !governmentOrg) ||
                (employmentType !== 'government' && !privateOrgName) ||
                !region ||
                !city ||
                !center
              }
            >
              {t('otherEmployment.save', 'حفظ التغييرات')}
            </button>
          </footer>
        )}
      </section>
    </div>
  );
};

export default EmployeeOtherEmployment;
